/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<circle
				opacity="0.4"
				cx="19"
				cy="5"
				r="3"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M12 3H10C7.19974 3 5.79961 3 4.73005 3.54497C3.78924 4.02433 3.02433 4.78924 2.54497 5.73005C2 6.79961 2 8.19974 2 11V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22H13C15.8003 22 17.2004 22 18.27 21.455C19.2108 20.9757 19.9757 20.2108 20.455 19.27C21 18.2004 21 16.8003 21 14V12"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<circle opacity="0.12" cx="19" cy="5" r="3" fill="currentColor" />
			<path
				d="M12 3H10C7.19974 3 5.79961 3 4.73005 3.54497C3.78924 4.02433 3.02433 4.78924 2.54497 5.73005C2 6.79961 2 8.19974 2 11V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22H13C15.8003 22 17.2004 22 18.27 21.455C19.2108 20.9757 19.9757 20.2108 20.455 19.27C21 18.2004 21 16.8003 21 14V12M22 5C22 6.65685 20.6569 8 19 8C17.3431 8 16 6.65685 16 5C16 3.34315 17.3431 2 19 2C20.6569 2 22 3.34315 22 5Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				d="M9.25 2.25C6.44974 2.25 5.04961 2.25 3.98005 2.79497C3.03924 3.27433 2.27433 4.03924 1.79497 4.98005C1.25 6.04961 1.25 7.44974 1.25 10.25V14.75C1.25 17.5503 1.25 18.9504 1.79497 20.02C2.27433 20.9608 3.03924 21.7257 3.98005 22.205C5.04961 22.75 6.44974 22.75 9.25 22.75H13.75C16.5503 22.75 17.9504 22.75 19.02 22.205C19.9608 21.7257 20.7257 20.9608 21.205 20.02C21.75 18.9504 21.75 17.5503 21.75 14.75V12.5357C21.75 12.2701 21.75 12.1373 21.7249 12.0275C21.6395 11.653 21.347 11.3605 20.9725 11.2751C20.8627 11.25 20.7299 11.25 20.4643 11.25C18.8707 11.25 18.074 11.25 17.4149 11.0996C15.1679 10.5867 13.4133 8.8321 12.9004 6.58513C12.75 5.92604 12.75 5.12926 12.75 3.53571C12.75 3.27012 12.75 3.13733 12.7249 3.02748C12.6395 2.65298 12.347 2.36055 11.9725 2.27507C11.8627 2.25 11.7299 2.25 11.4643 2.25H9.25Z"
				fill="currentColor"
			/>
			<path
				d="M19 1.25C16.9289 1.25 15.25 2.92893 15.25 5C15.25 7.07107 16.9289 8.75 19 8.75C21.0711 8.75 22.75 7.07107 22.75 5C22.75 2.92893 21.0711 1.25 19 1.25Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M12 3H8.5C7.10547 3 6.40821 3 5.83277 3.13815C4.00453 3.57707 2.57707 5.00453 2.13815 6.83277C2 7.40821 2 8.10547 2 9.5V9.5V10M21 12V14C21 16.8003 21 18.2004 20.455 19.27C19.9757 20.2108 19.2108 20.9757 18.27 21.455C17.2004 22 15.8003 22 13 22H8.5C7.10547 22 6.40821 22 5.83277 21.8618C4.00453 21.4229 2.57707 19.9955 2.13815 18.1672C2 17.5918 2 16.8945 2 15.5V15.5V15M22 5C22 6.65685 20.6569 8 19 8C17.3431 8 16 6.65685 16 5C16 3.34315 17.3431 2 19 2C20.6569 2 22 3.34315 22 5Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M12 3H10C7.19974 3 5.79961 3 4.73005 3.54497C3.78924 4.02433 3.02433 4.78924 2.54497 5.73005C2 6.79961 2 8.19974 2 11V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22H13C15.8003 22 17.2004 22 18.27 21.455C19.2108 20.9757 19.9757 20.2108 20.455 19.27C21 18.2004 21 16.8003 21 14V12M22 5C22 6.65685 20.6569 8 19 8C17.3431 8 16 6.65685 16 5C16 3.34315 17.3431 2 19 2C20.6569 2 22 3.34315 22 5Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M9.25 2.25C6.44974 2.25 5.04961 2.25 3.98005 2.79497C3.03924 3.27433 2.27433 4.03924 1.79497 4.98005C1.25 6.04961 1.25 7.44974 1.25 10.25V14.75C1.25 17.5503 1.25 18.9504 1.79497 20.02C2.27433 20.9608 3.03924 21.7257 3.98005 22.205C5.04961 22.75 6.44974 22.75 9.25 22.75H13.75C16.5503 22.75 17.9504 22.75 19.02 22.205C19.9608 21.7257 20.7257 20.9608 21.205 20.02C21.75 18.9504 21.75 17.5503 21.75 14.75V12.5357C21.75 12.2701 21.75 12.1373 21.7249 12.0275C21.6395 11.653 21.347 11.3605 20.9725 11.2751C20.8627 11.25 20.7299 11.25 20.4643 11.25C18.8707 11.25 18.074 11.25 17.4149 11.0996C15.1679 10.5867 13.4133 8.8321 12.9004 6.58513C12.75 5.92604 12.75 5.12926 12.75 3.53571C12.75 3.27012 12.75 3.13733 12.7249 3.02748C12.6395 2.65298 12.347 2.36055 11.9725 2.27507C11.8627 2.25 11.7299 2.25 11.4643 2.25H9.25Z"
				fill="currentColor"
			/>
			<path
				d="M19 1.25C16.9289 1.25 15.25 2.92893 15.25 5C15.25 7.07107 16.9289 8.75 19 8.75C21.0711 8.75 22.75 7.07107 22.75 5C22.75 2.92893 21.0711 1.25 19 1.25Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
